// extracted by mini-css-extract-plugin
export var gif = "_f9-0";